import { gql } from "@apollo/client";

const UPDATE_USER_GUIDE = gql`
  mutation UpdateUserGuide(
    $agentId: ID!
    $welcomeTourCompleted: Boolean
    $teamSetupCompleted: Boolean
    $postFbConnectionCompleted: Boolean
    $dashboardTourCompleted: Boolean
    $reportsTourCompleted: Boolean
    $chatScreenTourCompleted: Boolean
    $channelConnected: Boolean
    $settingsTourCompleted: Boolean
    $facebookGuideCompleted: Boolean
    $instagramGuideCompleted: Boolean
    $whatsappGuideCompleted: Boolean
  ) {
    updateUserGuide(
      agentId: $agentId
      welcomeTourCompleted: $welcomeTourCompleted
      teamSetupCompleted: $teamSetupCompleted
      postFbConnectionCompleted: $postFbConnectionCompleted
      dashboardTourCompleted: $dashboardTourCompleted
      reportsTourCompleted: $reportsTourCompleted
      chatScreenTourCompleted: $chatScreenTourCompleted
      channelConnected: $channelConnected
      settingsTourCompleted: $settingsTourCompleted
      facebookGuideCompleted: $facebookGuideCompleted
      instagramGuideCompleted: $instagramGuideCompleted
      whatsappGuideCompleted: $whatsappGuideCompleted
    ) {
      success
    }
  }
`;
export default UPDATE_USER_GUIDE;
